export default "__VITE_ASSET__DBxoEg22__"